export default __webpack_public_path__ + "static/media/status_icon.c46c6d6d.png";